import React, {useState, useEffect, useRef} from "react";
import {Modal, DatePicker, Form, Popconfirm, Button, Space} from "antd";
import moment from "moment";
import locale from "antd/es/date-picker/locale/tr_TR";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";

const CourierVionTransitionModal = ({
    open,
    onCancel,
    courierId,
    onSuccess,
    providerCompany,
    providerCompanyName = "Sağlayıcı Firma",
    initialDate
}) => {
    const stores = useStore();
    const [transitionDate, setTransitionDate] = useState(initialDate ? moment(initialDate) : null);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [checkMessage, setCheckMessage] = useState("");
    const payloadRef = useRef({});

    const [updateLoading, , , , runUpdate] = useFetch({
        fetchFn: () => stores.courierStore.updateProviderCompany(payloadRef.current),
        initialCall: false,
        callbackFunc: ok => {
            if (ok) {
                onSuccess?.();
                onCancel();
            }
        }
    });

    const [checkLoading, , , , runCheck] = useFetch({
        fetchFn: () => stores.courierStore.checkProviderCompany(payloadRef.current),
        initialCall: false,
        callbackFunc: result => {
            if (!result) return; // hata zaten error modal ile gösterildi
            if (result.hasProcessedRecords) {
                setCheckMessage(result.message);
                setConfirmVisible(true);
            } else {
                runUpdate();
            }
        }
    });

    const loading = checkLoading || updateLoading;

    useEffect(() => {
        if (open) {
            setTransitionDate(initialDate ? moment(initialDate) : null);
            setConfirmVisible(false);
            setCheckMessage("");
        }
    }, [open, initialDate]);

    const handleSaveClick = () => {
        if (!transitionDate) return;
        payloadRef.current = {
            courierId,
            providerCompany,
            transitionDate: moment(transitionDate).format("YYYY-MM-DD")
        };
        runCheck();
    };

    return (
        <Modal
            visible={open}
            onCancel={onCancel}
            title={`Sağlayıcı Firma - ${providerCompanyName}`}
            footer={
                <div style={{textAlign: "right"}}>
                    <Space>
                        <Button key="cancel" onClick={onCancel} disabled={loading}>
                            İptal Et
                        </Button>
                        <Popconfirm
                            key="save"
                            visible={confirmVisible}
                            title={checkMessage}
                            okText="Kaydet"
                            cancelText="İptal Et"
                            onConfirm={() => {
                                setConfirmVisible(false);
                                runUpdate();
                            }}
                            onCancel={() => setConfirmVisible(false)}
                        >
                            <Button
                                type="primary"
                                loading={loading}
                                disabled={!transitionDate}
                                onClick={handleSaveClick}
                                data-testid="vionTransitionModalSaveButton"
                            >
                                Kaydet
                            </Button>
                        </Popconfirm>
                    </Space>
                </div>
            }
            destroyOnClose
        >
            <Form layout="vertical">
                <Form.Item
                    label={`Kuryenin, hangi tarihten itibaren sağlayıcı firması ${providerCompanyName} olarak başlatılmalıdır?`}
                >
                    <DatePicker
                        value={transitionDate}
                        onChange={date => setTransitionDate(date)}
                        placeholder="Sağlayıcı Firmaya Geçiş Tarihi Giriniz"
                        format="DD.MM.YYYY"
                        locale={locale}
                        style={{width: "100%"}}
                        data-testid="vionTransitionModalDatePicker"
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CourierVionTransitionModal;
